import { useCallback } from 'react';
import { useOptionalKatonMeet } from './KatonMeetContext';
import ToasterWithMessage from '../toaster';
import { KATON_MEET_MESSAGES } from '../../utils/constants';

const { info } = ToasterWithMessage();

// Logging out while a live class is open (full screen or PiP) would drop the user from the meeting
// without leaving it properly. Returns true when the logout must be blocked and tells the user to leave
// first; the meeting stays in its current mode. Only for logouts the user starts; automatic logouts
// (session expiry, access revoked) are not blocked.
export const useKatonMeetLogoutGuard = () => {
  const session = useOptionalKatonMeet()?.session;

  // message: what to tell the user (defaults to the logout one; e.g. a different one for changing class)
  return useCallback(
    (message: string = KATON_MEET_MESSAGES.leaveBeforeLogout) => {
      if (!session) return false;
      info(message);
      return true;
    },
    [session],
  );
};
